import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-evo-stats-change-card-medium',
  templateUrl: './evo-stats-change-card-medium.component.html',
  styleUrls: ['./evo-stats-change-card-medium.component.css']
})
export class EvoStatsChangeCardMediumComponent implements OnInit {

  @Input() iconURL: string;
  @Input() titleToTranslate: string;
  @Input() value = '';

  @Output() onClick = new EventEmitter<void>();


  constructor() { }

  ngOnInit() {
  }

}
